/* GOPSHOP – Kategorie-Center (sections/gop-hub.liquid) + Anfrage-Kacheln
   – Sofortsuche über alle Kacheln (Name + Suchbegriffe, Umlaute egal), Filter-Chips pro Gruppe
   – zusätzlich Produkte über Shopify Predictive Search (/search/suggest.json)
   – Kacheln/Buttons mit data-wish füllen das Wunschformular vor (Event „gop:wish-prefill“, sonst Startseite #gop-wish) */
(function () {
  'use strict';

  var PREFILL_KEY = 'gop-wish-prefill';

  function norm(s) {
    return String(s || '')
      .replace(/\u00ad/g, '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .replace(/ß/g, 'ss')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* 10.10.: Suche/Anfrage nach Nachbauten (window.gopFakeRx im <head>) – GOPSHOP besorgt keine Replikas */
  function isFakeQ(t) {
    var R = window.gopFakeRx;
    return !!(R && R.test && R.test(String(t || '')));
  }

  /* ---------- Wunschformular vorbefüllen ---------- */
  function askWish(text) {
    text = String(text || '').replace(/\u00ad/g, '').trim().slice(0, 120);
    if (!text) return false;
    if (isFakeQ(text)) return false;
    if (document.querySelector('[data-gop-wish]')) {
      document.dispatchEvent(new CustomEvent('gop:wish-prefill', { detail: { text: text } }));
      return true;
    }
    try {
      window.sessionStorage.setItem(PREFILL_KEY, text);
    } catch (e) {
      /* ohne Vorbefüllung */
    }
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    window.location.href = root + '#gop-wish';
    return true;
  }
  window.gopAskWish = askWish;

  if (!window.__gopWishClicks) {
    window.__gopWishClicks = true;
    document.addEventListener('click', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('[data-wish]') : null;
      if (!a || e.metaKey || e.ctrlKey || e.shiftKey) return;
      e.preventDefault();
      askWish(a.getAttribute('data-wish'));
    });
  }

  /* ---------- Freistellen: weißen Fotohintergrund entfernen (Canvas, gleiche Domain) ---------- */
  document.documentElement.classList.add('gh-js');
  var cutQ = [];
  var cutBusy = false;
  var idle = window.requestIdleCallback || function (f) { return setTimeout(f, 30); };

  function showImg(img) {
    img.classList.add('is-cut');
  }

  /* reine Pixel-Funktion: läuft im Web Worker (oder als Rückfall im Hauptthread). true = freigestellt */
  function cutPixels(p, cw, ch) {
    var white = function (i) {
      return p[i + 3] > 245 && p[i] > 246 && p[i + 1] > 246 && p[i + 2] > 246;
    };
    var corners = [0, (cw - 1) * 4, (ch - 1) * cw * 4, ((ch - 1) * cw + cw - 1) * 4];
    var n = 0;
    for (var c = 0; c < 4; c++) if (white(corners[c])) n++;
    if (n < 3) return false; // schon freigestellt (transparent) oder echtes Foto
    var seen = new Uint8Array(cw * ch);
    var st = [];
    var k;
    for (k = 0; k < cw; k++) st.push(k, (ch - 1) * cw + k);
    for (k = 0; k < ch; k++) st.push(k * cw, k * cw + cw - 1);
    while (st.length) {
      k = st.pop();
      if (seen[k]) continue;
      var i = k * 4;
      if (!white(i)) continue;
      seen[k] = 1;
      p[i + 3] = 0;
      var xx = k % cw;
      var yy = (k - xx) / cw;
      if (xx > 0) st.push(k - 1);
      if (xx < cw - 1) st.push(k + 1);
      if (yy > 0) st.push(k - cw);
      if (yy < ch - 1) st.push(k + cw);
    }
    /* weiche Kante gegen weiße Säume */
    for (k = 0; k < cw * ch; k++) {
      if (seen[k]) continue;
      var j = k * 4;
      var x2 = k % cw;
      var y2 = (k - x2) / cw;
      var nb = (x2 > 0 && seen[k - 1]) || (x2 < cw - 1 && seen[k + 1]) || (y2 > 0 && seen[k - cw]) || (y2 < ch - 1 && seen[k + cw]);
      if (!nb) continue;
      var m = Math.min(p[j], p[j + 1], p[j + 2]);
      if (m > 228) p[j + 3] = Math.round((p[j + 3] * (255 - m)) / 27);
    }
    return true;
  }

  var worker = null;
  var jobs = {};
  var jobId = 0;
  try {
    if (window.Worker && window.OffscreenCanvas && window.createImageBitmap && window.Blob) {
      var src =
        cutPixels.toString() +
        '\nself.onmessage=function(e){var d=e.data;try{var c=new OffscreenCanvas(d.w,d.h);var x=c.getContext("2d",{willReadFrequently:true});' +
        'x.drawImage(d.bmp,0,0,d.w,d.h);if(d.bmp.close)d.bmp.close();var im=x.getImageData(0,0,d.w,d.h);' +
        'if(!cutPixels(im.data,d.w,d.h)){self.postMessage({id:d.id});return;}x.putImageData(im,0,0);' +
        'c.convertToBlob({type:"image/png"}).then(function(b){self.postMessage({id:d.id,blob:b});},function(){self.postMessage({id:d.id});});' +
        '}catch(err){self.postMessage({id:d.id});}};';
      worker = new Worker(URL.createObjectURL(new Blob([src], { type: 'text/javascript' })));
      worker.onmessage = function (e) {
        var job = jobs[e.data.id];
        delete jobs[e.data.id];
        if (job) job(e.data.blob || null);
      };
      worker.onerror = function () {
        worker = null;
      };
    }
  } catch (e) {
    worker = null;
  }

  function applyBlob(img, blob) {
    if (!blob) return showImg(img);
    img.onload = function () { showImg(img); };
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.src = URL.createObjectURL(blob);
  }

  function cutImg(img, done) {
    var w = img.naturalWidth;
    var h = img.naturalHeight;
    if (!w || !h) {
      showImg(img);
      return done();
    }
    var sc = Math.min(1, 440 / Math.max(w, h));
    var cw = Math.max(1, Math.round(w * sc));
    var ch = Math.max(1, Math.round(h * sc));
    if (worker) {
      createImageBitmap(img, { resizeWidth: cw, resizeHeight: ch, resizeQuality: 'medium' })
        .then(function (bmp) {
          var id = ++jobId;
          jobs[id] = function (blob) {
            applyBlob(img, blob);
            done();
          };
          worker.postMessage({ id: id, bmp: bmp, w: cw, h: ch }, [bmp]);
        })
        .catch(function () {
          showImg(img);
          done();
        });
      return;
    }
    /* Rückfall: im Hauptthread */
    var c = document.createElement('canvas');
    c.width = cw;
    c.height = ch;
    var x = c.getContext('2d', { willReadFrequently: true });
    x.drawImage(img, 0, 0, cw, ch);
    var d = x.getImageData(0, 0, cw, ch);
    if (!cutPixels(d.data, cw, ch)) {
      showImg(img);
      return done();
    }
    x.putImageData(d, 0, 0);
    c.toBlob(function (b) {
      applyBlob(img, b);
      done();
    }, 'image/png');
  }

  /* nur rechnen, wenn gerade nicht gescrollt wird */
  var scrollT = 0;
  window.addEventListener('scroll', function () { scrollT = performance.now(); }, { passive: true });

  function pump() {
    if (cutBusy || !cutQ.length) return;
    if (performance.now() - scrollT < 220) {
      setTimeout(pump, 220);
      return;
    }
    cutBusy = true;
    var img = cutQ.shift();
    idle(function () {
      var fin = function () {
        cutBusy = false;
        pump();
      };
      try {
        cutImg(img, fin);
      } catch (e) {
        showImg(img);
        fin();
      }
    }, { timeout: 400 });
  }

  function queueCut(img) {
    if (img.__cq) return;
    img.__cq = true;
    function go() {
      setTimeout(function () { showImg(img); }, 5000); // Sicherheitsnetz
      cutQ.push(img);
      pump();
    }
    if (img.complete && img.naturalWidth) go();
    else {
      img.addEventListener('load', go, { once: true });
      img.addEventListener('error', function () { showImg(img); }, { once: true });
    }
  }

  function cutAll(scope) {
    scope.querySelectorAll('.gt__img--cut').forEach(queueCut);
  }
  window.gopCutAll = cutAll;

  /* ---------- Kategorie-Center ---------- */
  /* 7.13: Sicherheitsfilter für alte Einträge im Shopify-Suchindex (Entwürfe mit Replika-Texten, Produktseite 404) */
  var FLAG = /(^|\D)1:1(\D|$)|1-1-high|high[- ]end|replic|replik|super ?-?clone|\bclones?\b|\bdupes?\b|u1[- ]factory|\bu1\b|factory|clean[- ]factory|copy[- ]version|ogq|kaum vom original|bemerken nichts|badge ?codes?|identisch/i;
  /* Titel/Handle: breite Begriffe; Produkttext: nur eindeutige Wendungen (sonst träfe es z. B. „U1-Chip“, „factory sealed“).
     gopLive (im <head>, bei ≤ 50 Produkten): nur wirklich veröffentlichte Produkte zeigen – der Suchindex liefert sonst alte Entwürfe (404). */
  var FLAG_BODY = /super\s*-?\s*clone|replic|replik|u1\s*-?\s*factory|clean\s*-?\s*factory|kaum\s+vom\s+original|bemerken\s+nichts|badge\s*codes?|(^|\D)1:1(\D|$)/i;
  function gopBad(p) {
    if (FLAG.test((p.title || '') + ' ' + (p.handle || '')) || FLAG_BODY.test(p.body || '')) return true;
    var L = window.gopLive;
    return !!(L && L.indexOf && L.indexOf(p.handle) < 0);
  }
  /* leerer Katalog (window.gopCatalogCount === 0, gesetzt im <head>): keine Produkttreffer aus der Vorschlagssuche –
     die liefert sonst alte Entwurfs-Produkte; dann nur Kategorien und „Anfragen“ */
  function catalogEmpty() {
    return window.gopCatalogCount === 0;
  }

  function money(v) {
    var n = parseFloat(v);
    if (!isFinite(n)) return '';
    var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'de', { style: 'currency', currency: cur }).format(n);
    } catch (e) {
      return n.toFixed(2) + ' ' + cur;
    }
  }

  function init(root) {
    if (root.__gh) return;
    root.__gh = true;

    var q = root.querySelector('[data-gh-q]');
    var form = root.querySelector('[data-gh-form]');
    var clearBtn = root.querySelector('[data-gh-clear]');
    var chipsBar = root.querySelector('[data-gh-chips]');
    var status = root.querySelector('[data-gh-status]');
    var empty = root.querySelector('[data-gh-empty]');
    var term = root.querySelector('[data-gh-term]');
    var askBtn = root.querySelector('[data-gh-ask]');
    var prodBox = root.querySelector('[data-gh-products]');
    var plist = root.querySelector('[data-gh-plist]');
    var results = root.querySelector('[data-gh-results]');
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-gh-group]'));
    var overview = root.querySelector('[data-gh-overview]');
    var tiles = Array.prototype.slice.call(root.querySelectorAll('[data-gh-group] [data-gt]'));
    var suggestUrl = root.getAttribute('data-suggest') || '';
    var searchUrl = root.getAttribute('data-search') || '/search';
    var tFound = root.getAttribute('data-t-found') || '[n]';
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    tiles.forEach(function (t) {
      t._k = ' ' + norm(t.getAttribute('data-k')) + ' ';
    });

    var state = { group: 'all', q: '' };
    var prodCount = 0;
    var pending = false;

    /* Domino: sichtbare Gruppen neu „austeilen“ (nach Filter/Suche) */
    function replay() {
      if (reduce) return;
      groups.forEach(function (g) {
        if (g.hidden || g.offsetParent === null) return;
        g.classList.remove('is-dealt');
        void g.offsetWidth;
        g.classList.add('is-dealt');
      });
    }

    function apply(animate) {
      var words = norm(state.q).split(' ').filter(Boolean);
      var searching = words.length > 0;
      var total = 0;
      groups.forEach(function (g) {
        var key = g.getAttribute('data-gh-group');
        var inGroup = state.group === 'all' || state.group === key;
        var n = 0;
        g.querySelectorAll('[data-gt]').forEach(function (t) {
          var ok =
            inGroup &&
            (!searching ||
              words.every(function (w) {
                return t._k.indexOf(w) >= 0;
              }));
          t.hidden = !ok;
          if (ok) n++;
        });
        g.hidden = n === 0;
        total += n;
      });
      root.setAttribute('data-view', searching ? 'search' : state.group === 'all' ? 'all' : 'group');
      root.querySelectorAll('.gh__chip').forEach(function (c) {
        var on = c.getAttribute('data-gh-chip') === state.group;
        c.classList.toggle('is-on', on);
        c.setAttribute('aria-pressed', String(on));
      });
      if (clearBtn) clearBtn.hidden = !state.q;
      if (status) status.textContent = searching ? tFound.replace('[n]', total) : '';
      if (term) term.textContent = '„' + state.q.trim() + '“';
      var shownProducts = prodCount;
      var fakeQ = searching && isFakeQ(state.q);
      if (empty) {
        empty.hidden = !(searching && ((total === 0 && shownProducts === 0 && !pending) || fakeQ));
        empty.classList.toggle('is-fake', fakeQ);
        if (!empty.__x) {
          var ex = empty.querySelector('.gh__empty-x');
          empty.__x = ex ? ex.textContent : '';
        }
        var exEl = empty.querySelector('.gh__empty-x');
        var en = (document.documentElement.lang || '').slice(0, 2) === 'en';
        if (exEl) exEl.textContent = fakeQ ? (en ? 'We can\'t offer anything for this term. Try searching by brand and model.' : 'Zu diesem Begriff können wir dir nichts anbieten. Such gern nach Marke und Modell.') : empty.__x;
        if (askBtn) askBtn.hidden = fakeQ;
        var etEl = empty.querySelector('.gh__empty-t');
        if (etEl) {
          if (!empty.__t) empty.__t = etEl.innerHTML;
          if (fakeQ) etEl.textContent = en ? 'No results.' : 'Keine Treffer.';
          else if (etEl.textContent !== empty.__t) { etEl.innerHTML = empty.__t; term = etEl.querySelector('[data-gh-term]'); if (term) term.textContent = '„' + state.q.trim() + '“'; }
        }
      }
      if (animate) replay();
    }

    /* Produkte live mitsuchen */
    var timer = 0;
    var ctrl = null;
    function suggest() {
      clearTimeout(timer);
      if (ctrl) ctrl.abort();
      var text = state.q.trim();
      prodCount = 0;
      if (plist) plist.innerHTML = '';
      if (prodBox) prodBox.hidden = true;
      if (!suggestUrl || text.length < 2 || !window.fetch || catalogEmpty()) {
        pending = false;
        return;
      }
      pending = true;
      timer = setTimeout(function () {
        ctrl = window.AbortController ? new AbortController() : null;
        var url =
          suggestUrl +
          '.json?q=' +
          encodeURIComponent(text) +
          '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
        fetch(url, { signal: ctrl ? ctrl.signal : undefined, headers: { Accept: 'application/json' } })
          .then(function (r) {
            return r.ok ? r.json() : null;
          })
          .then(function (d) {
            pending = false;
            var list = ((d && d.resources && d.resources.results && d.resources.results.products) || []).filter(function (p) {
              return !gopBad(p);
            });
            prodCount = list.length;
            if (plist && list.length) {
              plist.innerHTML = list
                .map(function (p, i) {
                  var img = (p.featured_image && p.featured_image.url) || p.image || '';
                  if (img && img.indexOf('?') < 0) img += '?width=400';
                  else if (img) img += '&width=400';
                  return (
                    '<a class="gt gt--product" href="' + esc(p.url) + '" style="--i:' + i + '"><span class="gt__media">' +
                    (img ? '<img class="gt__img gt__img--cut" src="' + esc(img) + '" alt="" loading="lazy">' : '') +
                    '</span><span class="gt__title">' + esc(p.title) + '</span>' +
                    (p.price ? '<span class="gt__price">' + esc(money(p.price)) + '</span>' : '') +
                    '</a>'
                  );
                })
                .join('');
            }
            if (prodBox) {
              prodBox.hidden = !list.length;
              /* 7.13 – F5: Produkt-Gruppe wird nie vom Domino-Beobachter erfasst → sonst bleiben die Karten
                 unsichtbar (opacity 0 unter .is-armed), sind aber klickbar */
              if (list.length) {
                prodBox.classList.remove('is-dealt');
                void prodBox.offsetWidth;
                prodBox.classList.add('is-dealt');
              }
            }
            if (plist) cutAll(plist);
            if (results) results.href = searchUrl + '?q=' + encodeURIComponent(text) + '&options%5Bprefix%5D=last';
            apply(false);
          })
          .catch(function (err) {
            if (err && err.name === 'AbortError') return;
            pending = false;
            apply(false);
          });
      }, 260);
    }

    if (q) {
      q.addEventListener('input', function () {
        state.q = q.value;
        if (state.q.trim() && state.group !== 'all') state.group = 'all';
        apply(false);
        suggest();
      });
      q.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && q.value) {
          q.value = '';
          state.q = '';
          suggest();
          apply(true);
        }
      });
    }
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (q) q.blur();
      });
    }
    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        q.value = '';
        state.q = '';
        suggest();
        apply(true);
        q.focus();
      });
    }

    root.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-gh-chip]');
      if (chip) {
        var g = chip.getAttribute('data-gh-chip');
        var fromHead = !chip.classList.contains('gh__chip');
        state.group = g === state.group && g !== 'all' ? 'all' : g;
        apply(true);
        var on = root.querySelector('.gh__chip.is-on');
        if (on && chipsBar) {
          chipsBar.scrollTo({ left: on.offsetLeft - (chipsBar.clientWidth - on.offsetWidth) / 2, behavior: reduce ? 'auto' : 'smooth' });
        }
        if (fromHead && chipsBar) chipsBar.scrollIntoView({ block: 'start', behavior: reduce ? 'auto' : 'smooth' });
        return;
      }
      if (e.target.closest('[data-gh-ask]')) {
        e.preventDefault();
        askWish(state.q);
      }
    });

    /* Domino beim Scrollen: jede Gruppe wird ausgeteilt, sobald sie ins Bild kommt */
    /* 7.4: Übersicht (Kategorien) ist sofort sichtbar – kein Ausblenden bis zum Einscrollen, kein Leerraum */
    domino(root, groups);
    /* Aurora nur animieren, solange die Sektion sichtbar ist */
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        root.classList.toggle('is-off', !en[0].isIntersecting);
      }).observe(root);
    }

    if (askBtn) askBtn.setAttribute('href', '#gop-wish');
    apply(false);
    cutAll(root);
  }

  /* ---------- Domino-Einblendung: Karten rutschen nacheinander hinter der vorherigen hervor ---------- */
  function domino(root, list) {
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    root.classList.add('is-armed');
    var io = new IntersectionObserver(
      function (en) {
        en.forEach(function (x) {
          if (!x.isIntersecting) return;
          io.unobserve(x.target);
          x.target.classList.add('is-dealt');
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
    );
    list.forEach(function (g) { io.observe(g); });
  }

  /* ---------- Marken-Bühne: Luftstrom-Animation nur, wenn sichtbar ---------- */
  function initShowcase(root) {
    if (root.__gs) return;
    root.__gs = true;
    cutAll(root);
    var tiles = root.querySelector('.gs__tiles');
    if (tiles) domino(root, [tiles]);
    if (!('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (en) {
      root.classList.toggle('is-paused', !en[0].isIntersecting);
    }).observe(root);
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-gop-hub]').forEach(init);
    (scope || document).querySelectorAll('[data-gop-showcase]').forEach(initShowcase);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
